// extracted by mini-css-extract-plugin
module.exports = {"redirectingLabel":"styles__redirectingLabel___2a5Sj"};